// extracted by mini-css-extract-plugin
export var actionText = "_r3-4";
export var container = "_r3-0";
export var leftSection = "_r3-1";
export var rightSection = "_r3-2";
export var settingsButton = "_r3-6";
export var settingsIcon = "_r3-7";
export var shortcut = "_r3-5";
export var shortcutGroup = "_r3-3";